import * as React from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import styled from "@emotion/styled";
import HomeIcon from "@mui/icons-material/Home";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import DiscountIcon from "@mui/icons-material/Discount";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import CategoryIcon from "@mui/icons-material/Category";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import PaidIcon from "@mui/icons-material/Paid";
import ApartmentIcon from "@mui/icons-material/Apartment";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import LogOutModal from "./modal";
import BurstModeIcon from "@mui/icons-material/BurstMode";
import { useModal } from "../modal";
import { useNavigate } from "react-router-dom";
const Text = styled(ListItemText)({
  textAlign: "right",
});
const ItemButton = styled(ListItemButton)({
  borderRadius: "10px",
  "& .MuiTypography-root": {
    fontFamily: "'Yekan !important'",
  },
  "& .MuiListItemIcon-root": {
    minWidth: "unset",
    marginLeft: ".5rem",
  },
});

const Datafacilities = [
  // { name: "دسته بندی", icon: <CategoryIcon />, address: "/categories" },
  { name: "دوره ها", icon: <OndemandVideoIcon />, address: "/courses" },
  // { name: "صفحات تغییرپذیر", icon: <LibraryAddCheckIcon />, address: "/dynumic-pages" },
];
const adminFacilities = [
  { name: "کاربران", icon: <PeopleAltIcon />, address: "/users" },
  { name: "بنر ها", icon: <BurstModeIcon />, address: "/banners" },
  // { name: "ticketing", icon: <ConfirmationNumberIcon />, address: "/ticketing" },
  // { name: "ارگان های متصل", icon: <ApartmentIcon />, address: "/" },
  // { name: "ویدیو درباره ما", icon: <VideoFileIcon />, address: "/" },
  // { name: "نظرات", icon: <LightbulbIcon />, address: "/reviews" },
  // { name: "پرسش ها", icon: <LiveHelpIcon />, address: "/comments" },
  // { name: "پرداخت ها", icon: <PaidIcon />, address: "/payments" },
  // { name: "کدتخفیف", icon: <DiscountIcon />, address: "/vouchers" },
  { name: "سازمان ها", icon: <ApartmentIcon />, address: "/organs" },
  // { name: "مجوزها", icon: <WorkspacePremiumIcon />, address: "/" },
];
export default function AppbarMenuItems() {
  const [open, setOpen] = React.useState(false);
  const [expand, setExpand] = React.useState(false);
  const { setShow, setContent } = useModal();
  const navigate = useNavigate();
  const handleClick = () => {
    setOpen(!open);
  };
  const handleOpenModal = (type: string) => {
    if (type === "logout") {
      setContent({
        title: "خروج از حساب کاربری",
        body: <LogOutModal />,
      });
    }
    setShow(true);
  };
  return (
    <List
      sx={{ width: "100%", maxHeight: "80vh", overflow: "auto" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ItemButton onClick={() => navigate("/")}>
        <ListItemIcon>
          <HomeIcon sx={{ color: "divider" }} />
        </ListItemIcon>
        <Text primary="پنل مدیریت" />
      </ItemButton>
      <ItemButton sx={{ bgcolor: "primary.main" }} onClick={handleClick}>
        <Text primary="امکانات محتوی" />
        {open ? <RemoveIcon /> : <AddIcon />}
      </ItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {Datafacilities.map((item, index) => {
            return (
              <ItemButton
                onClick={() => navigate(item.address)}
                key={index}
                sx={{ pl: 4 }}
              >
                <ListItemIcon sx={{ color: "divider" }}>
                  {item.icon}
                </ListItemIcon>
                <Text primary={item.name} />
              </ItemButton>
            );
          })}
        </List>
      </Collapse>
      <ItemButton
        onClick={() => setExpand(!expand)}
        sx={{ bgcolor: "primary.main" }}
      >
        <Text primary="امکانات ادمین" />
        {expand ? <RemoveIcon /> : <AddIcon />}
      </ItemButton>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {adminFacilities.map((item, index) => {
            return (
              <ItemButton
                onClick={() => navigate(item.address)}
                key={index}
                sx={{ pl: 4 }}
              >
                <ListItemIcon sx={{ color: "divider" }}>
                  {item.icon}
                </ListItemIcon>
                <Text primary={item.name} />
              </ItemButton>
            );
          })}
        </List>
      </Collapse>
      <ItemButton onClick={() => navigate("/profile")}>
        <ListItemIcon>
          <SettingsIcon sx={{ color: "divider" }} />
        </ListItemIcon>
        <Text primary="تنظیمات" />
      </ItemButton>
      <ItemButton onClick={() => handleOpenModal("logout")}>
        <ListItemIcon>
          <LogoutIcon sx={{ color: "divider" }} />
        </ListItemIcon>
        <Text primary="خروج از حساب" />
      </ItemButton>
    </List>
  );
}
